export const FILTER_CLEAR = 'FILTER_CLEAR';

export const FILTER_IS_OPEN = 'FILTER_IS_OPEN';

export const FILTER_LANGUAGE = 'FILTER_LANGUAGE';

export const FILTER_SELECTED_TOPICS = 'FILTER_SELECTED_TOPICS';

export const FILTER_SELECTED_CATEGORIES = 'FILTER_SELECTED_CATEGORIES';

export const FILTER_OPEN_CATEGORIES = 'FILTER_OPEN_CATEGORIES';
